import compose from 'lodash.flowright';
import xml2js from './helpers/xml2js';
import {
  get,
  getAll,
  getFirstChild,
  getText,
  getAttributes,
  getAttribute
} from './helpers/xmlSelectors';

const parser = new DOMParser();

const parseBase64 = compose(decodeURIComponent, window.escape, window.atob);

/**
 * Parses the passed xml text.
 *
 * @global
 * @typedef parseXml
 * @throws if there is an error parsing the xml.
 * @param {string} xmlText - XML text to be parsed.
 * @returns {Object} - Returns the parsed xml document as a js object.
 * @static
 */
const parseXml = (xmlText) => {
  let xmlToParse = xmlText;

  if (xmlText.indexOf('data:') === 0) {
    xmlToParse = parseBase64(xmlToParse.split(',', 2)[1]);
  }

  return xml2js(parser, xmlToParse);
};

export {
  get,
  getAll,
  getFirstChild,
  getText,
  getAttributes,
  getAttribute,
  parseXml
};
